(function () {
  function setImportant(el, prop, value) {
    if (!el) return;
    el.style.setProperty(prop, value, 'important');
  }

  function fixCartQuantity() {
    document.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
      var wrapper =
        input.closest('quantity-selector-component') ||
        input.closest('.quantity-selector') ||
        input.parentElement;

      if (!wrapper) return;

      wrapper.classList.add('nfp-cart-qty-fixed');

      /* Wrapper */
      setImportant(wrapper, 'display', 'grid');
      setImportant(wrapper, 'grid-template-columns', '44px 42px 44px');
      setImportant(wrapper, 'align-items', 'center');
      setImportant(wrapper, 'justify-content', 'center');
      setImportant(wrapper, 'gap', '0');
      setImportant(wrapper, 'width', '130px');
      setImportant(wrapper, 'min-width', '130px');
      setImportant(wrapper, 'max-width', '130px');
      setImportant(wrapper, 'height', '44px');
      setImportant(wrapper, 'min-height', '44px');
      setImportant(wrapper, 'padding', '0');
      setImportant(wrapper, 'overflow', 'hidden');
      setImportant(wrapper, 'background', 'transparent');
      setImportant(wrapper, 'border', '1px solid #F28C28');
      setImportant(wrapper, 'border-radius', '4px');
      setImportant(wrapper, 'box-shadow', 'none');

      /* Minus and plus buttons */
      wrapper.querySelectorAll('button').forEach(function (button) {
        setImportant(button, 'display', 'inline-flex');
        setImportant(button, 'align-items', 'center');
        setImportant(button, 'justify-content', 'center');
        setImportant(button, 'width', '44px');
        setImportant(button, 'min-width', '44px');
        setImportant(button, 'max-width', '44px');
        setImportant(button, 'height', '44px');
        setImportant(button, 'min-height', '44px');
        setImportant(button, 'padding', '0');
        setImportant(button, 'margin', '0');
        setImportant(button, 'background', 'transparent');
        setImportant(button, 'border', '0');
        setImportant(button, 'border-radius', '0');
        setImportant(button, 'box-shadow', 'none');
        setImportant(button, 'outline', '0');
        setImportant(button, 'color', '#1F3140');
        setImportant(button, 'font-family', '"Poppins", system-ui, sans-serif');
        setImportant(button, 'font-size', '20px');
        setImportant(button, 'font-weight', '800');
        setImportant(button, 'line-height', '1');
        setImportant(button, 'transform', 'none');

        if (button.getAttribute('name') === 'minus') {
          setImportant(button, 'grid-column', '1');
        }

        if (button.getAttribute('name') === 'plus') {
          setImportant(button, 'grid-column', '3');
        }
      });

      /* Quantity number */
      setImportant(input, 'display', 'inline-block');
      setImportant(input, 'grid-column', '2');
      setImportant(input, 'width', '42px');
      setImportant(input, 'min-width', '42px');
      setImportant(input, 'max-width', '42px');
      setImportant(input, 'height', '44px');
      setImportant(input, 'min-height', '44px');
      setImportant(input, 'padding', '0');
      setImportant(input, 'margin', '0');
      setImportant(input, 'background', 'transparent');
      setImportant(input, 'border', '0');
      setImportant(input, 'box-shadow', 'none');
      setImportant(input, 'outline', '0');
      setImportant(input, 'color', '#111111');
      setImportant(input, 'font-family', '"Poppins", system-ui, sans-serif');
      setImportant(input, 'font-size', '15px');
      setImportant(input, 'font-weight', '900');
      setImportant(input, 'line-height', '44px');
      setImportant(input, 'text-align', 'center');
      setImportant(input, 'opacity', '1');
      setImportant(input, 'visibility', 'visible');
      setImportant(input, '-webkit-text-fill-color', '#111111');
    });

    /* Trash/remove button */
    document.querySelectorAll('button.cart-items__remove').forEach(function (button) {
      setImportant(button, 'display', 'inline-flex');
      setImportant(button, 'align-items', 'center');
      setImportant(button, 'justify-content', 'center');
      setImportant(button, 'width', '44px');
      setImportant(button, 'min-width', '44px');
      setImportant(button, 'max-width', '44px');
      setImportant(button, 'height', '44px');
      setImportant(button, 'min-height', '44px');
      setImportant(button, 'padding', '0');
      setImportant(button, 'margin', '0');
      setImportant(button, 'background', 'transparent');
      setImportant(button, 'border', '1px solid #F28C28');
      setImportant(button, 'border-radius', '4px');
      setImportant(button, 'box-shadow', 'none');
      setImportant(button, 'color', '#111111');
      setImportant(button, 'opacity', '1');
      setImportant(button, 'visibility', 'visible');
      setImportant(button, 'transform', 'none');

      var svg = button.querySelector('svg');
      if (svg) {
        setImportant(svg, 'display', 'block');
        setImportant(svg, 'width', '20px');
        setImportant(svg, 'height', '20px');
        setImportant(svg, 'color', '#111111');
        setImportant(svg, 'opacity', '1');
        setImportant(svg, 'visibility', 'visible');
      }

      button.querySelectorAll('path').forEach(function (path) {
        setImportant(path, 'stroke', '#111111');
        setImportant(path, 'opacity', '1');
        setImportant(path, 'visibility', 'visible');
      });
    });
  }

  function runFix() {
    fixCartQuantity();
  }

  document.addEventListener('DOMContentLoaded', runFix);
  window.addEventListener('load', runFix);
  document.addEventListener('shopify:section:load', runFix);

  new MutationObserver(runFix).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
